<template>
  <div>
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div :style="{ width }" class="modal-container">
            <div class="modal-header">
              <slot name="header" />
              <CloseIcon class="modal-close" @click="close" />
            </div>

            <div class="modal-body">
              <slot name="body" />
            </div>

            <div class="modal-footer">
              <slot name="footer">
                <button class="modal-default-button" @click="close">
                  OK
                </button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import CloseIcon from './assets/svg/icon-close.svg?vue-component';

export default {
  components: {
    CloseIcon,
  },
  props: {
    modal: { type: String, default: '' },
    width: { type: String, default: '' },
  },
  mounted() {
    const vm = this;
    this.$root.$on('emit-click', (e) => {
      if (e.target.classList.contains('modal-wrapper')) {
        this.close();
      }
    });
    document.addEventListener('keyup', (evt) => {
      if (evt.keyCode === 27) {
        vm.close();
      }
    });
  },
  methods: {
    close() {
      document.body.classList.remove('modal-open');
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
/* modal */
#modal {
  transition: 1.3s ease;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  transition: transform 0.3s ease-out;
  display: inline-grid;
  overflow-x: hidden;
  overflow-y: auto;
}

.modal-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
}

.modal-container {
  padding: var(--spacing-sm);
  background: var(--true-white);
  width: 96%;
  max-width: 580px;
  margin: 0 auto;
  border-radius: 4px;
  overflow: hidden;
  transition: all 1.3s ease;
}

.modal-header {
  display: flex;
  padding-bottom: var(--spacing-sm);
  justify-content: space-between;
  align-items: center;

  h1 {
    font-weight: bold;
    font-size: 21.33px !important;
    line-height: 26px;
    color: var(--true-black) !important;
    margin: 0 !important;
  }

  .modal-close {
    cursor: pointer;
    transform: scale(0.7);
    height: 18px;
  }
}

.modal-footer {
  display: flex;
  align-items: center;
}

.modal-footer .modal-default-text {
  flex: 1;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
